import React from 'react';

export default {
  logoBuilder: '',
  beta: '',
  title: (<></>),
  description: '',
  choosePlan: '',
  freePlan: '',
  free: '',
  freePlanDescription: '',
  continueWithFree: '',
  freeSpecs: [],
  paidPlan: '',
  paidPlanPrice: (<></>),
  yearlyPrice: '',
  paidPlanDescription: (<></>),
  startNow: '',
  paidSpecs: [],
  modalLogoGeneration: {
    thankYouForInterest: (<></>),
    itIsATest: (<></>),
    tellUsAboutYourBrand: '',
    brandName: '',
    brandSlogan: '',
    category: '',
    categories: [],
    selectColor: '',
    colors: [],
    back: '',
    create: '',
    errorMessage: '',
    helpTextSlogan: '',
    generatingLogo: '',
  },
  modalPaidPlan: {
    modalPaidPlanTitle: (<></>),
    stepItemTitleFreeTrial: (<></>),
    stepItemSubtitleFreeTrial: '',
    stepItemSubtitleReminder: '',
    stepItemSubtitleCharge: '',
    boxSummaryTitle: '',
    buttonContinue: '',
  },
  infosLogoBuilderSuccessModal: {
    title: (
      <>
      </>
    ),
    message: '',
    buttonLabel: '',
  },
};
